<!-- Change class of the following div to change app-theme -->

<div class="flex-col flex-justify-space-between light-theme flex-align-center app-wrapper">

    <!-- Toolbar stays fixed at top, outside sidenav-container -->
    <dottnet-toolbar [sidenav]="sidenav" [user]="user$ | async" [authLoginState]="authLoginState$ | async"  [topic]="topic$ | async" [topics]="topics$ | async" [headerBannerContent]="headerBannerContent$ | async" (userMenuClick)="onUserMenuClick()" />

    <!-- Sidenav container below toolbar -->
    <mat-sidenav-container class="sidenav-below-toolbar">
        <mat-sidenav #sidenav mode="over" autoFocus="false">
            <dottnet-sidenav [sidenav]="sidenav" [user]="user$ | async" [authLoginState]="authLoginState$ | async" [subjects]="subjects$ | async" [specializations]="specializations$ | async" (userMenuClick)="onUserMenuClick()" />
        </mat-sidenav>
        <mat-sidenav #userMenuSidenav mode="over" position="end" autoFocus="false">
            <dottnet-user-menu-panel [user]="user$ | async" [isOpen]="isUserMenuOpen()" (closePanel)="onUserMenuClose()" />
        </mat-sidenav>
        <mat-sidenav-content id="sidenav-content" class="flex-col flex-justify-space-between desktop-content">

            <dottnet-consent-management />

            <div class="flex-row flex-justify-center outlet-container">
                <router-outlet #o="outlet" />
            </div>
            <dottnet-footer [authLoginState]="authLoginState()" [facebookLink]="fbLink" [twitterLink]="twitterLink" [linkedinLink]="linkedinLink" [instagramLink]="instagramLink" />
        </mat-sidenav-content>
    </mat-sidenav-container>
</div>
